/* unplugin-vue-components disabled */import script from "./IndexCardItem.vue?vue&type=script&setup=true&lang=tsx"
export * from "./IndexCardItem.vue?vue&type=script&setup=true&lang=tsx"

import "./IndexCardItem.vue?vue&type=style&index=0&id=46b36442&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b36442"]])

export default __exports__